import { FC } from 'react';
import { css, keyframes, useTheme } from '@emotion/react';
import { Easing } from 'client/Theme';

const iconStyle = css`
  overflow: visible;
`;

const filledAnimation = keyframes`
  0% {
    transform: translate3d(0px, 0px, 0) rotate(0deg);
  };
  50% {
    transform: translate3d(36px, -36px, 0) rotate(-0.01deg);
  };
  100% {
    transform: translate3d(0px, 0px, 0) rotate(0deg);
  };
`;

const hollowAnimation = keyframes`
  0% {
    transform: translate3d(0px, 0px, 0) rotate(0deg);
  };
  50% {
    transform: translate3d(-36px, 36px, 0) rotate(0.01deg);
  };
  100% {
    transform: translate3d(0px, 0px, 0) rotate(0deg);
  };
`;

const filledAnimatedStyle = css`
  animation: ${filledAnimation} 1600ms infinite ${Easing.springy};
`;

const hollowAnimatedStyle = css`
  animation: ${hollowAnimation} 1600ms infinite ${Easing.springy};
`;

export const Clone: FC<{ size?: number; color?: string; animate?: boolean }> = ({ size = 36, color = undefined, animate = false }) => {
  const theme = useTheme();
  if (!color) color = theme.color.grey[100];
  return (
    <svg viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg" width={size} height={size} css={iconStyle}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72 36V120H156V36H72ZM66 24C62.6863 24 60 26.6863 60 30V126C60 129.314 62.6863 132 66 132H162C165.314 132 168 129.314 168 126V30C168 26.6863 165.314 24 162 24H66Z"
        fill={color}
        css={[animate && hollowAnimatedStyle]}
      />
      <path
        d="M24 66C24 62.6863 26.6863 60 30 60H126C129.314 60 132 62.6863 132 66V162C132 165.314 129.314 168 126 168H30C26.6863 168 24 165.314 24 162V66Z"
        fill={color}
        css={[animate && filledAnimatedStyle]}
      />
    </svg>
  );
};
